export const Admin = {
  tabLabel1: 'Novo Parceiro',
  tabLabel2: 'Novo Utilizador',
  tabLabel3: 'Gestão de Frotas'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/Admin.js